import React, { createContext, useReducer } from 'react';
import { IL10N } from '../../Common/l10n-keys';
import { ArticleTileContextActionType } from '../../Common/enums';
import { ICurrencyInformation } from '../articleTileGrid/article-tile/article-tile.d';
import { IUrlController } from './UrlController';

export const ArticleTileContext = createContext({
    l10n: {} as IL10N,
    categoryName: '',
    cdnUrl: '',
    mspOrigin: '',
    isGlobal: false,
    isMobile: false,
    currencyInformation: {} as ICurrencyInformation,
    urlController: {} as IUrlController,
    culture:'',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setMspOrigin: (origin: string) => { },
    focusFirstTileInNewPage: () => { },
});

function catStateReducer(state, action) {
    if (action.type === ArticleTileContextActionType.SetMspOrigin) {
        return {
            mspOrigin: action.payload.mspOrigin,
        };
    }

    return {
        mspOrigin: '',
    };
}

export default function ArticleTileContextProvider(
    props: React.PropsWithChildren<{
        l10n: IL10N, cdnUrl: string,
        isGlobal?: boolean, isMobile?: boolean,
        currencyInformation?: ICurrencyInformation, categoryName?: string,
        urlController?: IUrlController,
        culture?: string
    }>,) {
    const [catState, catStateDispatch] = useReducer(catStateReducer, { mspOrigin: '' });

    function setMspOrigin(origin: string) {
        catStateDispatch({ type: ArticleTileContextActionType.SetMspOrigin, payload: { mspOrigin: origin } });
    }

    function focusFirstTileInNewPage() {

    }

    const ctxValue = {
        l10n: props.l10n,
        cdnUrl: props.cdnUrl,
        setMspOrigin: setMspOrigin,
        mspOrigin: catState.mspOrigin,
        focusFirstTileInNewPage: focusFirstTileInNewPage,
        isGlobal: props.isGlobal,
        isMobile: props.isMobile,
        currencyInformation: props.currencyInformation,
        categoryName: props.categoryName,
        urlController: props.urlController,
        culture: props.culture
    };

    return (
        <ArticleTileContext.Provider value={ctxValue}>
            {props.children}
        </ArticleTileContext.Provider>
    );
}
